import React from 'react'
import { Link } from 'gatsby'

import { Links } from './index.styled'

const Terms = ({ className, onClick = () => {} }) => {
  return (
    <Links className={className} onClick={onClick}>
      <li>
        <Link to='/legal/'>TERMS AND CONDITIONS</Link>
      </li>
      <li>
        <Link to='/legal#policy'>PRIVACY NOTICE</Link>
      </li>
    </Links>
  )
}

export default Terms
